<template>
  <div v-if="show">
    <div class="container">
      <div class="card2">
        <!-- <van-tabs v-model="active" @change="changeActive">
          <van-tab title="审核数据">
            <div style="margin: 10px 0 0 10px">
              <van-tag size="large" round type="primary" v-if="info.checkStatus == 0">待审核</van-tag>
              <van-tag size="large" round type="success" v-if="info.checkStatus == 4 || info.checkStatus == 6">审核通过</van-tag>
              <van-tag size="large" round type="danger" v-if="info.checkStatus == 5">审核不通过</van-tag>
            </div>
            <div class="list-wrap van-hairline--top">
              <div class="item" style="width: 48%">
                <span class="key">部门：</span>
                <span class="value">{{info.deptName}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">时间：</span>
                <span class="value">{{info.month}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">餐补人数：</span>
                <span class="value">{{info.userCount}}人</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">餐补次数：</span>
                <span class="value">{{info.mealCount}}次</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">餐补标准：</span>
                <span class="value">{{info.mealStandard}}元/次</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">餐补总费用：</span>
                <span class="value">{{ info.mealMoney }}(元)</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="加班明细"> -->
            <!-- <div class="mxtitle">
              <span class="mx-son">时间：2022年7月</span>
              <span class="mx-son">餐补：2 人</span>
              <span class="mx-son">次数：10次</span>
              <span class="mx-son">总费用：¥ 150</span>
            </div> -->
            <div class="btns">
              <!-- <van-button size="small" type="info" @click="handleReviewer(info)">部门经理审核</van-button> -->
              <van-tag plain :type="info.checkStatus == 0?'warning':info.checkStatus == 5?'danger':'primary'" style="height: 20px;">
                <span v-if="info.checkStatus == 0">待审核</span>
                <span v-if="info.checkStatus == 4 || info.checkStatus == 6 || info.checkStatus == 7">审核通过</span>
                <span v-if="info.checkStatus == 5">审核不通过</span>
              </van-tag>
              <van-search style="width: 86%;" v-model="queryParams.userName" placeholder="请输入员工姓名进行搜索" @search="queryCustList" @input="queryCustList" />
              <!-- <div class="check_tip">审核状态为通过，人员餐补状态为通过的数据将上报人力资源审批后核发餐补</div> -->
            </div>
          <!-- </van-tab>
        </van-tabs> -->
      </div>
      <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
        <total-component :totalValue="total" />
        <!-- <div class="batch_operation" v-if="info.checkStatus == 0">
          <div class="batch_tip">不需要审核的人员可以先选择不通过(不勾选则表示所有数据)</div>
          <van-button size="small" type="info" v-hasPermi="['admi:overTimeStatisticsDetail:confirmAll']" @click="handleReviewerAll">通过</van-button>
          <van-button size="small" color="#ee0a24" v-hasPermi="['admi:overTimeStatisticsDetail:notConfirmAll']" @click="handleFailAll">不通过</van-button>
        </div> -->
        <!-- <div class="check_all" v-if="queryParams.userName"><van-checkbox v-model="isCheckedAll" @click="checkedAll" shape="square">全选</van-checkbox></div> -->
        <van-checkbox-group v-model="checkGroup" ref="checkboxGroup">
          <van-cell v-for="(item, index) in list" :key="index" >
            <div style="display: flex; align-items: center; height:100%; width:100%">
              <van-checkbox :name="item.overtimeStatisticsUserId" style="margin-right: 10px;" shape="square"></van-checkbox>
              <div style="flex: 1;" @click="toUserDetail(item.userId)">
                <div class="custName-wrap" style="padding: 0;">
                  <div class="custName">
                    <span style="color: #409EFF;margin-right: 10px">{{item.userName}}</span>
                    <!-- {{item.offDutyDay + '    ' + removeYmd(item.offDutyTime)}} -->
                    <van-tag color="#67C23A" v-if="item.checkStatus == 2"> 通过 </van-tag>
                    <van-tag color="#F56C6C" v-if="item.checkStatus == 3"> 不通过 </van-tag>
                  </div>
                </div>
                <div style="color: #333; font-size: 12px">{{item.deptName}}</div>
                <div style="color: #333; font-size: 12px">餐补次数：{{item.mealCount}}次    餐补总费用(元)： {{item.mealMoney}}元</div>
              </div>
              <!-- <van-button size="mini" type="info" v-hasPermi="['admi:overTimeStatisticsDetail:confirm']" v-if="info.checkStatus == 0" @click="handleReviewer(item)">审核</van-button> -->
            </div>
          </van-cell>
        </van-checkbox-group>
      </van-list>
      <empty-component v-if="isEmpty" />
      <!-- <van-grid class="grid-wrap" :column-num="2" v-if="info.checkStatus == 0">
        <van-grid-item>
          <div class="flex-center">
            <van-icon name="sign" size="22" color="#07c160" />
            <span @click="handleConfirm(info)">确认</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center">
            <van-icon name="delete" size="22" color="#ee0a24" />
            <span @click="handleReject(info)">驳回</span>
          </div>
        </van-grid-item>
      </van-grid> -->
    </div>
    <div class="batch_bottom" v-if="info.checkStatus == 0" v-hasPermi="['admi:overTimeStatistics:edit']">
      <!-- 部门经理审核 -->
      <van-button size="small" type="primary" @click="handleReviewer(info)">事业部经理审核</van-button>
    </div>
    <!-- <div class="tip" v-if="info.checkStatus == 0">
      说明：列表中复选框选项不选择时表示所有记录，批量通过或批量不通过将批量处理所有记录。
    </div> -->
    <van-dialog v-model="showUserDetail" class="cust" width="97%" style="height: 80%;overflow: scroll;" title="个人餐补详情" :showConfirmButton = 'false' :close-on-click-overlay="true">
      <van-list class="van-list" v-model="userDetailLoading" style="height: 80%" :finished="userDetailFinished" finished-text="没有更多了" @load="userDetailOnLoad" v-if="userDetailList.length > 0">
        <van-cell v-for="(item,index) in userDetailList" :key="index" >
          <div class="flex-between">
            <div>
              <div class="custName-wrap" style="padding: 0;">
                <div class="custName">
                  <span style="color: #409EFF;margin-right: 10px">{{item.userName}}{{item.offDutyDay + '    ' + removeYmd(item.offDutyTime)}}/{{weekArr[item.week]}}</span>
                  <!--  -->
                  <van-tag color="#67C23A" v-if="item.checkStatus == 2"> 通过 </van-tag>
                  <van-tag color="#F56C6C" v-if="item.checkStatus == 3"> 不通过 </van-tag>
                </div>
              </div>
              <div style="color: #333; font-size: 12px">{{item.deptName}}</div>
            </div>
          </div>
        </van-cell>
      </van-list>
      <empty-component v-if="userDetailList == 0" />
    </van-dialog>
    <van-dialog v-model="verifyFormShow" title="餐补审核" width="95%" style="height:65%" class="verifyClue" :beforeClose="verifyBeforeClose" show-cancel-button>
      <van-form ref="verifyForm" validate-trigger="onSubmit">
        <!-- <van-cell v-if="verifyForm.offDutyTime" :title="verifyForm.userName" :value="verifyForm.offDutyDay +'    '+ verifyForm.offDutyTime.substring(10,19)" /> -->
        <van-cell v-if="verifyForm.deptName" title="部门名称" :value="verifyForm.deptName.split('/')[0]" />
        <van-cell title="餐补人数" :value="this.info.userCount + '人'" />
        <van-cell title="餐补总次数" :value="this.info.mealCount + '次'" />
        <van-cell title="餐补费用合计" :value="this.info.mealMoney + '元'" />
        <van-cell title="确认状态：" required >
          <template>
            <van-radio-group v-model="verifyForm.checkStatus" direction="horizontal">
              <van-radio name="4" clickable @click="verifyForm.checkStatus = '4'">通过</van-radio>
              <van-radio name="5" clickable @click="verifyForm.checkStatus = '5'">不通过</van-radio>
            </van-radio-group>
          </template>
        </van-cell>
        <van-field
          v-model="verifyForm.checkReason"
          rows="2"
          autosize
          label="审核意见"
          placeholder="请输入审核意见"
          type="textarea"
          show-word-limit
          :rules="verifyForm.checkStatus == '5'?[{ required: true }]:[]" :required="verifyForm.checkStatus == '5'?true:false"
        />
      </van-form>
    </van-dialog>
    <van-dialog v-model="approvalFormShow" title="驳回原因" width="95%" style="height:50%" class="approvalClue" :beforeClose="approvalBeforeClose" show-cancel-button>
      <van-form ref="approvalForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="approvalForm.checkReason"
            autosize required
            label="驳回原因"
            placeholder="请输入驳回原因"
            type="textarea"
            show-word-limit
            :rules="[{ required: true }]"/>
        </van-cell-group>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>

import mealTonic from '@/api/admi/mealTonic'
// import { getDicts } from '@/api/system/dict/data'
import { Dialog, Toast, Checkbox, CheckboxGroup } from 'vant'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'

export default {
  components: {
    EmptyComponent,
    TotalComponent,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  watch: {
    checkGroup: {
      handler(val, oldVal) {
        if (this.list.length == val.length) { this.isCheckedAll = true } else if (this.list.length != val.length) {
          this.isCheckedAll = false
        }
      }
    }
  },
  data() {
    return {
      isCheckedAll: false,
      checkGroup: [],
      show: false,
      active: 0,
      overtimeStatisticsId: '',
      info: {},
      loading: false,
      finished: false,
      list: [],
      total: 0,
      isEmpty: false,
      queryParams: {
        pageNum: 1,
        pageSize: 25,
        overtimeStatisticsId: null,
        deptId: null,
        deptName: null,
        userName: null,
        monthStr: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      approvalFormShow: false,
      approvalForm: { },
      verifyFormShow: false,
      verifyForm: {},
      showUserDetail: false,
      userDetailTotal: 0,
      userDetailLoading: false,
      userDetailFinished: false,
      userDetailList: [],
      userDetailQuery: {
        pageNum: 1,
        pageSize: 20,
        monthStr: null,
        userId: null
      },
      weekArr: ['', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
    }
  },
  async created() {
    const id = this.$route.query.id
    this.overtimeStatisticsId = id
    this.queryParams.deptId = this.$route.query.deptId
    this.queryParams.monthStr = this.getPreMonth()
    // this.queryParams.overtimeStatisticsId = id
    await this.getDetail()
    // this.handleList()
  },
  mounted() {
    // this.getCustLevelList();
    this.init()
    // this.queryListVisit();
  },
  methods: {
    // showImage(url) {
    //   this.imagesArr = url.split(',')
    //   this.imagePreviewShow = true
    // },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    async init() {
      // 修改主体框架标题
      document.title = '餐补详情'
    },
    getNowMonth() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = month > 9 ? month : '0' + month
      var nowMonth = year + '-' + month
      return nowMonth
    },
    /** 获取上一个月 */
    getPreMonth() {
      var arr = this.getNowMonth().split('-')
      var year = arr[0] // 获取当前日期的年份
      var month = arr[1] // 获取当前日期的月份

      var year2 = year
      var month2 = parseInt(month) - 1
      if (month2 == 0) {
        // 1月的上一月是前一年的12月
        year2 = parseInt(year2) - 1
        month2 = 12
      }

      if (month2 < 10) {
        // 10月之前都需要补0
        month2 = '0' + month2
      }
      var preMonth = year2 + '年' + month2 + '月'
      return preMonth
    },
    async getDetail() {
      const res = await mealTonic.getMealTonicMain(this.overtimeStatisticsId)
      if (res.code === 200) {
        this.show = true
        this.info = res.data
        this.queryParams.overtimeStatisticsId = res.data.overtimeStatisticsId
      }
    },
    changeActive(index) {
      this.active = index
      if (index == 1) {
        this.queryCustList()
      }
    },
    async handleConfirm(row) {
      // this.approvalForm = row
      // this.approvalFormShow = true
      Dialog.confirm({
        message: `是否确认审核通过${this.queryParams.monthStr}餐补，总费用¥${row.mealMoney}(元)`
      })
        .then(() => {
          const obj = row
          obj.checkStatus = '4'
          obj.isCause = '1'
          obj.checkReason = '事业部确认通过'
          mealTonic.auditMealTonicMain(obj).then(res => {
            if (res.code === 200) {
              Toast.success('操作成功')
              setTimeout(() => {
                this.getDetail()
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleReject(row) {
      this.approvalForm = row
      this.approvalFormShow = true
    },
    async approvalBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          this.approvalForm.isCause = '1'
          this.approvalForm.checkStatus = '5'
          await this.$refs.approvalForm.validate()
          await mealTonic.auditMealTonicMain(this.approvalForm)
            .then(() => {
              Toast.success('驳回成功')
              this.approvalFormShow = false
              setTimeout(() => {
                this.getDetail()
              }, 500)
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.approvalFormShow = false
      }
    },

    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      // this.queryParams.pageSize = 25
      this.handleList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    async handleList() {
      this.loading = true
      const res = await mealTonic.listMealTonic(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    removeYmd(val) {
      return val.split(' ')[1]
    },
    onLoad() {
      this.handleList()
    },
    // 个人详细列表
    toUserDetail(val) {
      this.userDetailList = []
      this.userDetailQuery.userId = val
      this.userDetailQuery.monthStr = this.queryParams.monthStr
      this.handleUserDetailList()
      this.showUserDetail = true
    },
    async handleUserDetailList() {
      this.userDetailLoading = true
      const res = await mealTonic.getMealTonic(this.userDetailQuery)
      if (res.code === 200) {
        if (res.data.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.userDetailList = this.userDetailList.concat(...res.data.rows)
        this.userDetailQuery.pageNum += 1
        this.userDetailTotal = res.data.total
        this.userDetailFinished = this.userDetailList.length >= res.data.total
        this.userDetailLoading = false
      }
    },
    userDetailOnLoad() {
      this.handleUserDetailList()
    },
    handleReviewer(row) {
      this.verifyForm = { ...row, checkStatus: '4' }
      // this.verifyForm.checkStatus = '4'
      this.verify = '45'
      this.verifyForm.isCause = '1'
      this.verifyFormShow = true
    },
    // 审核
    async verifyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.verifyForm.validate()
          // mealTonic.confirmMealTonic(this.verifyForm).then(response => {
          mealTonic.auditMealTonicMain(this.verifyForm).then(response => {
            if (response.code == 200) {
              Toast.success('审核成功!')
              this.verifyFormShow = false
              setTimeout(() => {
                this.getDetail()
                this.queryCustList()
              }, 500)
            }
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    checkedAll() {
      if (this.isCheckedAll) {
        this.$refs.checkboxGroup.toggleAll(true)
      } else {
        this.$refs.checkboxGroup.toggleAll()
      }
    },
    handleReviewerAll() {
      const yearMonth = this.info.month.substring(0, 9).split('-')[0] + '年' + this.info.month.substring(0, 9).split('-')[1] + '月'
      let message = ''
      if (this.checkGroup.length > 0) {
        message = `当前选中${yearMonth}餐补共计${this.getMealNum()}次，餐补总费用${this.getMealNum() * 15}元（标准：15元/次），批量审核通过？`
      } else {
        message = `${this.info.deptName.split('/')[0] + yearMonth}餐补人数${this.info.userCount}人，餐补共计${this.info.mealCount}次，餐补总费用${this.info.mealMoney}元（标准：15元/次），批量审核通过？`
      }
      Dialog.confirm({
        message: message
      })
        .then(() => {
          const obj = {
            monthStr: yearMonth,
            deptId: this.info.deptId,
            overtimeStatisticsId: this.overtimeStatisticsId,
            ids: this.checkGroup.join(','),
            isManager: 1
          }
          mealTonic.batchConfirmMealTonic(obj).then(res => {
            if (res.code === 200) {
              Toast.success('批量审核通过成功')
              setTimeout(() => {
                this.queryCustList()
                this.checkGroup = []
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleFailAll() {
      const yearMonth = this.info.month.substring(0, 9).split('-')[0] + '年' + this.info.month.substring(0, 9).split('-')[1] + '月'
      let message = ''
      if (this.checkGroup.length > 0) {
        message = `当前选中${yearMonth}餐补共计${this.getMealNum()}次，餐补总费用${this.getMealNum() * 15}元（标准：15元/次），批量审核不通过？`
      } else {
        message = `${this.info.deptName.split('/')[0] + yearMonth}餐补人数${this.info.userCount}人，餐补共计${this.info.mealCount}次，餐补总费用${this.info.mealMoney}元（标准：15元/次），批量审核不通过？`
      }
      Dialog.confirm({
        message: message
      })
        .then(() => {
          const obj = {
            monthStr: yearMonth,
            deptId: this.info.deptId,
            overtimeStatisticsId: this.overtimeStatisticsId,
            ids: this.checkGroup.join(','),
            isManager: 1
          }
          mealTonic.batchFailMealTonic(obj).then(res => {
            if (res.code === 200) {
              Toast.success('批量审核不通过成功')
              setTimeout(() => {
                this.queryCustList()
                this.checkGroup = []
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    getMealNum() {
      const mealNumList = []
      if (this.checkGroup.length > 0) {
        this.checkGroup.forEach(item => {
          mealNumList.push(this.list.find(val => { return val.overtimeStatisticsUserId == item }).mealCount)
        })
        return mealNumList.reduce((prev, cur) => { return prev + cur })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");
.van-list{
  padding-top: 0;
  padding-bottom: 220px;
}
.container{
  padding: 0;
  .card2{
    background-color: #fff;
    padding: 20px;
    .mxtitle{
      background-color: #f5f5f5;
      padding: 2px 0;
      text-align: center;
      margin-top: 20px;
      .mx-son{
        margin-left: 10px;
      }
    }
  }
}
/deep/.van-tabs__content{
  margin-top: 20px;
  border-top: solid 2px #f5f5f5;
}
.gd_box{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.title{
  /deep/.van-tag{
    width: auto;
  }
}
.auditDetails /deep/.van-cell__value{
  -webkit-box-flex: 0.25;
  -webkit-flex: 0.25;
  flex: 0.25;
}
.auditDetails /deep/.van-dialog__content {
  height: 68%;
}
.approvalClue /deep/.van-dialog__content {
  height: 68%;
}
.fileClue /deep/.van-dialog__content {
  height: 80%;
}
/deep/.van-step__circle{
  background-color: #969799;
}
/deep/.van-step__line{
  background-color: #ebedf0;
}
.btns{
  display: flex;
  align-items: center;
  // justify-content: space-between;
  .check_tip{
    margin-left: 20px;
    font-size: 26px;
    line-height: 36px;
    color: #ff976a;
  }
  .van-button{
    width: 30%;
    border-radius: 10px;
  }
}
.batch_operation{
  // margin-left: 10px;
  // position: fixed;
  // bottom: calc(120px + env(safe-area-inset-bottom));
  // width: 98%;
  background-color: #fff;
  padding: 15px 10px;
  display: flex;
  align-items: center;
  border-bottom: 1px dashed #e4e4e4;
  // justify-content: flex-end;
  .van-button{
    width: 28%;
    margin-right: 10px;
    border-radius: 10px;
  }
  .batch_tip{
    font-size: 26px;
    line-height: 36px;
    color: #ff976a;
  }
}
.batch_bottom{
  // margin-left: 10px;
  position: fixed;
  bottom: calc(120px + env(safe-area-inset-bottom));
  width: 100%;
  background-color: #fff;
  padding: 20px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  .van-button{
    width: 36%;
    height: 80px;
    border-radius: 10px;
  }
}
.tip{
  color: #ee0a24;
  margin-top: 25px;
  font-size: 25px;
  line-height: 40px;
}
.verifyClue /deep/.van-dialog__content {
  height: 76%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
.check_all{
  background-color: #fff;
  padding: 10px 34px;
  border-bottom: 1px solid #e4e4e4;
  /deep/ .van-checkbox__label{
    font-size: 28px;
  }
}
.cust /deep/.van-dialog__content {
  height: 80%;
}
</style>
